import {combineReducers} from 'redux';
import admin from './admin';
import analytics from './analyticsReducer';
import auth from './authReducer';
import dashboard from './dashboardReducer';
import mediaList from './mediaListReducer';
import organization from './organizationReducer';
import settings from './settingsReducer';
import survey from './surveyReducer';
import surveyDetail from './surveyDetailReducer';
import surveyList from './surveyListReducer';
import surveyTrackers from './surveyTrackersReducer';
import surveyTags from './surveyTagsReducer';
import dashboardsConfigurationReducer from '../components/quicksightDashboards/redux/dashboardConfiguration/reducers';
import dashboardsReducer from '../components/quicksightDashboards/redux/quicksightUrl/reducers';
import exports from './exportReducer';


const appReducer = combineReducers({
    admin,
    analytics,
    auth,
    dashboard,
    mediaList,
    organization,
    settings,
    survey,
    surveyDetail,
    surveyList,
    surveyTrackers,
    surveyTags,
    dashboards: dashboardsReducer,
    dashboardsConfiguration: dashboardsConfigurationReducer,
    exports,

});

export default appReducer;
